import {FC} from "react"
import {Icon, IconName} from "../../buttons"
import {csvTableService} from "../../service/csvTableService"
import './CSVTableToolbar.less'

interface Props {
    content: string
    setContent: (content: string) => void
    cursorPosition?: { row: number; col: number }
}

export const CSVTableToolbar: FC<Props> = ({
    content,
    setContent,
    cursorPosition,
}) => {
    const handleAddRow = () => {
        setContent(csvTableService.getAfterAddRow(content))
    }

    const handleAddColumn = () => {
        setContent(csvTableService.getAfterAddColumn(content))
    }

    const handleDuplicateRow = () => {
        setContent(csvTableService.getAfterDuplicateRow(content, cursorPosition?.row ?? 0))
    }

    const handleDeleteRow = () => {
        setContent(csvTableService.getAfterDeleteRow(content, cursorPosition?.row ?? 0))
    }

    return (
        <div className='csv-table-toolbar'>
            <button
                className='csv-table-toolbar__button'
                onClick={handleAddRow}
                aria-label='Add row'
            >
                <Icon name={IconName.AddRow} className='csv-table-toolbar__icon' />
                Add row
            </button>
            <button
                className='csv-table-toolbar__button'
                onClick={handleAddColumn}
                aria-label='Add column'
            >
                <Icon name={IconName.Add} className='csv-table-toolbar__icon' />
                Add column
            </button>
            <button
                className='csv-table-toolbar__button'
                onClick={handleDuplicateRow}
                aria-label='Duplicate row'
            >
                <Icon name={IconName.Copy} className='csv-table-toolbar__icon' />
                Duplicate row
            </button>
            <button
                className='csv-table-toolbar__button'
                onClick={handleDeleteRow}
                aria-label='Delete row'
            >
                <Icon name={IconName.Delete} className='csv-table-toolbar__icon' />
                Delete row
            </button>
        </div>
    )
}
